import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-row project-body" }
const _hoisted_2 = { class: "d-row" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "d-row" }

import TileCard from "@/components/util/TileCard.vue";
import ServiceTable from "@/components/tables/ServiceTable.vue";
import TSInvoiceVue from "@/components/report/TSInvoice.vue";
import { useReportStore } from "@/stores/report";
import { useSettingsStore } from "@/stores/setting";
import { closeToast, showLoading, showToastError } from "@/toastification";
import jsPDF from "jspdf";
import { onMounted, reactive } from "vue";
import ServiceTeamsReport from "@/components/service_teams/ServiceTeamsReport.vue";
import { useServiceTeamsStore } from "@/stores/serviceTeams";
import { ServiceTeamItem } from "@/services/entities/ServiceTeams/ServiceTeamItem";


export default /*@__PURE__*/_defineComponent({
  __name: 'InvoicingView',
  setup(__props) {

const state = reactive({
    invoice: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() },
    showInvoice: false,
    showServiceTeams: false,
    serviceId: 0,
    pdfGenerating: false,
    serviceTeams: [] as ServiceTeamItem[],
});

const settingsStore = useSettingsStore();
const reportStore = useReportStore();
const teamsStore = useServiceTeamsStore();

onMounted(async () => {
    await settingsStore.loadServices();
    await teamsStore.loadServiceTeams();
})

async function loadInvoice(serviceId: number) {
    state.showServiceTeams = false;
    state.showInvoice = true;
    state.serviceId = serviceId;
    await reportStore.loadInvoiceData(serviceId, state.invoice.year, state.invoice.month + 1);
}

async function loadTeamsReports(serviceId: number) {
    state.showInvoice = false;
    state.showServiceTeams = true;
    state.serviceId = serviceId;
    state.serviceTeams = teamsStore.getServiceTeams.filter(st => st.service.id === serviceId);
}

const createPDF = async () => {
    state.pdfGenerating = true;
    const loadToast = showLoading("Generating PDF", 0);
    const pdf = new jsPDF({
        unit: 'px',
        format: [680, 930]
    });

    try {
        let i = 0;
        while (true) {
            const page = document.getElementById(`page_${i}`);
            if (!page) {
                break;
            }
            if (i > 1) {
                pdf.addPage();
            }
            await pdf.html(page, { y: 930 * i });
            i++;
        }
        pdf.save(`${reportStore.getInvoiceData.service.blpgCode}_${state.invoice.year}_${state.invoice.month + 1}.pdf`);
    } catch (error) {
        console.error(error);
        showToastError(`Error generating PDF: ${error}`);
    } finally {
        state.pdfGenerating = false;
        closeToast(loadToast);
    }
}


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TileCard, {
      id: "project-table",
      loaded: _unref(settingsStore).getServicesLoaded
    }, {
      body: _withCtx(() => [
        _createVNode(ServiceTable, {
          data: _unref(settingsStore).getServices,
          onDetail: loadInvoice,
          onTeams: loadTeamsReports
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["loaded"]),
    (state.showInvoice)
      ? (_openBlock(), _createBlock(TileCard, {
          key: 0,
          id: "invoice",
          loaded: _unref(reportStore).isInvoiceLoaded
        }, {
          body: _withCtx(() => [
            _createVNode(TSInvoiceVue, {
              class: "invoice-body",
              data: _unref(reportStore).getInvoiceData,
              year: state.invoice.year,
              service: _unref(settingsStore).getServices.find(a => a.id == state.serviceId),
              month: state.invoice.month + 1
            }, null, 8, ["data", "year", "service", "month"])
          ]),
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_VueDatePicker, {
                modelValue: state.invoice,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((state.invoice) = $event)),
                  _cache[1] || (_cache[1] = ($event: any) => (loadInvoice(state.serviceId)))
                ],
                "month-picker": "",
                clearable: false,
                teleport: true
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "accent",
                  onClick: createPDF,
                  disabled: state.pdfGenerating
                }, "Generate PDF", 8, _hoisted_4)
              ])
            ])
          ]),
          _: 1
        }, 8, ["loaded"]))
      : (state.showServiceTeams)
        ? (_openBlock(), _createBlock(TileCard, {
            key: 1,
            id: "project-table",
            loaded: true
          }, {
            body: _withCtx(() => [
              _createVNode(ServiceTeamsReport, {
                data: state.serviceTeams
              }, null, 8, ["data"])
            ]),
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_VueDatePicker, {
                  modelValue: state.invoice,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((state.invoice) = $event)),
                    _cache[3] || (_cache[3] = ($event: any) => (loadInvoice(state.serviceId)))
                  ],
                  "month-picker": "",
                  clearable: false,
                  teleport: true
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})